<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
    import { onMount } from 'svelte';
    import CustomInteractionDefault from './CustomInteractionDefault.svelte';

    onMount(() => {
        const itemEl = document.querySelector('.qti-item');
        if (itemEl) {
            itemEl.dataset.geogebraItem = true;
        }
    });
</script>

<style>
    /* Geogebra PCI adds `.qti-item .qti-customInteraction { height: 100% !important}` style,
      which causes height issues in Item and Test Previewer, in layouts like this:
        <grid-row>
            <col-12>
                <colrow>Geogebra PCI</colrow>
                <colrow>some other content</colrow>
            </col-12>
        </gird-row>
     */
    :global(.previewer-test-ui-component [data-geogebra-item='true'] .qti-customInteraction),
    :global(.previewer-item-ui-component [data-geogebra-item='true'] .qti-customInteraction) {
        height: unset !important;
    }
</style>

<CustomInteractionDefault {...$$props} />
